import React from 'react';

interface TranslationFieldProps {
  label: string;
  field: string;
  value?: string;
  placeholder: string;
  originalValue?: string;
  multiline?: boolean;
  onChange: (field: string, value: string) => void;
}

export function TranslationField({
  label,
  field,
  value,
  placeholder,
  originalValue,
  multiline = false,
  onChange
}: TranslationFieldProps) {
  return (
    <div>
      <label className="block text-sm font-medium text-gray-300 mb-2">
        {label} (original)
      </label>
      <div className="bg-white/5 border border-white/10 rounded-lg px-3 py-2 text-gray-400">
        {originalValue || label}
      </div>
      <div className="mt-2">
        <label className="block text-sm font-medium text-gray-300 mb-2">
          {label} translated
        </label>
        {multiline ? (
          <textarea
            value={value || ''}
            onChange={(e) => onChange(field, e.target.value)}
            className="w-full bg-white/5 border border-white/10 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-indigo-500"
            placeholder={placeholder}
            rows={3}
          />
        ) : (
          <input
            type="text"
            value={value || ''}
            onChange={(e) => onChange(field, e.target.value)}
            className="w-full bg-white/5 border border-white/10 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-indigo-500"
            placeholder={placeholder}
          />
        )}
      </div>
    </div>
  );
}